import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import {
  useEnhancedReturnRouteMatch,
  PATH_ENHANCED_RETURNS,
  STATUS_AWAITING_SHIPMENT,
  STATUS_PROCESSING,
  STATUS_FLAGGED,
  STATUS_COMPLETED,
  resetPageQueryParam,
} from '../../../../store/returns/returns.helpers';
import { SSRHeader } from './ssr-header';
import { SSRStatusTabs } from './ssr-status-tabs';

import gridPageStyles from '../../../../pages/grid-page.module.less';
import { PagingContextProvider } from '../../../../contexts/paging-context';
import { EnhancedReturnsContextProvider } from '../grids/enhanced-returns-context';
import { usePaging } from '../../../../hooks/use-paging';

const SSR_VALID_STATUS_VIEWS = [STATUS_AWAITING_SHIPMENT, STATUS_PROCESSING, STATUS_FLAGGED, STATUS_COMPLETED];

export const SSREnhancedReturnsContent = () => {
  const history = useHistory();
  const { storeGuid, statusViewId } = useEnhancedReturnRouteMatch();
  const { page, pageSize } = usePaging();

  useEffect(() => {
    if (storeGuid && !SSR_VALID_STATUS_VIEWS.includes(statusViewId)) {
      const newSearch = resetPageQueryParam(history.location.search);
      history.replace({
        pathname: `${PATH_ENHANCED_RETURNS}/${storeGuid}/${STATUS_AWAITING_SHIPMENT}`,
        search: newSearch,
      });
    }
  }, [history, storeGuid, statusViewId]);

  return (
    <div className={gridPageStyles['main-content']}>
      <PagingContextProvider page={page} pageSize={pageSize}>
        <EnhancedReturnsContextProvider>
          <div className={gridPageStyles['grid-header']}>
            <SSRHeader storeGuid={storeGuid} />
          </div>
          <SSRStatusTabs />
        </EnhancedReturnsContextProvider>
      </PagingContextProvider>
    </div>
  );
};
